import React, {Component} from 'react'
import {Nullable} from '../../../../app/TypeHelpers';
import {StyledDiv} from '../../../../styledComponents/StyledTypeDefinitions';
import styled from 'styled-components';
import {NatGetLoginBeforeMessageList} from '../../loginBeforeMessage/repository/NatGetLoginBeforeMessageList';
import {MainContainer, TxtBold} from '../../../../styledComponents/ContentsArea';
import {Box} from '@mui/material';
import {Colors} from '../../../../styledComponents/Constants';

interface Props {
    loginBeforeMessageList: NatGetLoginBeforeMessageList | null,
}

export default class NatResidentLoginBeforeMessageComponent extends Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    render(): Nullable<React.ReactElement> {
        if (this.props.loginBeforeMessageList !== null &&
            this.props.loginBeforeMessageList.details !== null &&
            this.props.loginBeforeMessageList.details.loginBeforeMessageMasterInfo !== null &&
            this.props.loginBeforeMessageList.details.loginBeforeMessageMasterInfo.length !== 0) {
            return (
                <Box pb={'15px'}>
                    <MainContainer>
                        <LoginBeforeMessageWarappar>
                            {
                                this.props.loginBeforeMessageList.details.loginBeforeMessageMasterInfo.map
                                ((condominiumInfo, index) =>
                                    <Separator key={index}>
                                        <TxtBold>
                                            {condominiumInfo.title}
                                        </TxtBold>
                                        <Box p={'15px'}>
                                            <div dangerouslySetInnerHTML={{__html: condominiumInfo.message}}/>
                                        </Box>
                                    </Separator>)
                            }
                        </LoginBeforeMessageWarappar>
                    </MainContainer>
                </Box>
            )
        } else {
            return null
        }
    }
}
// ログイン前メッセージ
const LoginBeforeMessageWarappar: StyledDiv = styled.div`
  height: 200px;
  margin: 0 0 15px;
  padding: 32px;
  border: 1px solid ${Colors.AccentLight};
  overflow-y: scroll;
`;
// 区切り線
export const Separator: StyledDiv = styled.div`
  border-bottom: 1px solid ${Colors.AccentLight};
  margin-bottom: 15px;

  &:last-child {
   border-bottom: initial;
   margin-bottom: initial;
  }
`;
